import React from 'react';
import './Footer.css';

function Footer({ profile = { name: 'سلمان بن عبدالله الحران' } }) {
  const getHijriYear = () => {
    const today = new Date();
    const gregorianYear = today.getFullYear();
    const gregorianMonth = today.getMonth() + 1;
    const gregorianDay = today.getDate();
    
    // حساب السنة الهجرية بناءً على التاريخ الميلادي
    // معادلة تقريبية: السنة الهجرية = (السنة الميلادية - 622) * 1.030684
    const hijriYear = Math.floor((gregorianYear - 622) * 1.030684);
    
    // تعديل بسيط بناءً على الشهر (لأن السنة الهجرية تبدأ في أوقات مختلفة)
    if (gregorianMonth <= 6) {
      return hijriYear.toString();
    } else {
      return (hijriYear + 1).toString();
    }
  };
  
  const currentYear = getHijriYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © {currentYear} هـ {profile.name} - جميع الحقوق محفوظة
        </p>
      </div>
    </footer>
  );
}

export default Footer;
